<template>
    <li class='li'>
        <dl>
            <dt>
                <div class='tit'>
                    <MenuName :menu='menu' :mainFlag='1'>
                        <strong>{{menu.name}}</strong>
                    </MenuName>
                </div>
                <div class='btnArea'>
                    <button type='button' class='btn del' @click='delMenu'/>
                </div>
            </dt>
            <!-- 카트 정보 -->
            <dd class='order'>
                <ul class='ul'>
                    <li><strong>{{$t('originalPrice')}}</strong><span>{{formatComma(menu.price)}}{{$t('MoneyUnit')}}</span></li>
                    <!-- 일반 옵션 -->
                    <li v-for='option in menu.option' :key='option.menuOptionCode'>
                        <strong>{{option.detailOption.menuDetailOptionName}}</strong>
                        <span>{{formatComma(option.detailOption.price)}}{{$t('MoneyUnit')}}</span>
                    </li>
                    <!-- 추가 옵션 -->
                    <li v-for='option in menu.additionalOption' :key='option.menuOptionCode'>
                        <strong>{{option.menuOptionName}}</strong>
                        <span>{{formatComma(option.price)}}{{$t('MoneyUnit')}}</span>
                    </li>
                    <!-- 선택 옵션 -->
                    <li v-for='(option, idx) in menu.optionalOption' :key='idx'>
                      <strong>{{option.detailOption.menuDetailOptionName}}</strong>
                      <span>{{formatComma(option.detailOption.price)}}{{$t('MoneyUnit')}}</span>
                    </li>
                </ul>
          </dd>
            <!-- 상품 개수 관리 -->
            <dd class='total'>
                <div class='qty'>
                    <div class='intRange type1'>
                        <button
                            type='button'
                            class='btn minus'
                            :class='{disabled: count === 1}'
                            @click='subCount'>
                            minus
                        </button>
                        <input v-model='count' class='input' readonly/>
                        <button
                            type='button'
                            class='btn plus'
                            @click='addCount'>
                            plus
                        </button>
                    </div>
                </div>
                <div class='sum'>
                    <strong>{{formatComma(menu.originPrice * count)}}</strong><span>{{$t('MoneyUnit')}}</span>
                </div>
            </dd>
        </dl>
    </li>
</template>
<script lang="js">
import MenuName from '@/components/Common/MenuName.vue'
import { CART_ITEM } from '@/utils/EndPoint'
import Vue from 'vue'
export default Vue.extend({
  name: CART_ITEM,
  props: ['menu', 'menuCode'],
  components: { MenuName },
  data () {
    return {
      count: this.menu.count
    }
  },
  watch: {
    menu () { this.count = this.menu.count },
    count () { this.menu.count = this.count }
  },
  methods: {
    subCount () {
      if (this.count > 1) {
        this.count--
        this.$emit('changeCount', -1, this.menu.originPrice * -1)
      }
    },
    addCount () {
      this.count++
      this.$emit('changeCount', 1, this.menu.originPrice)
    },
    delMenu () {
      this.$emit('delMenu', this.menu, this.menuCode)
    }
  }
})
</script>
